import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { CreateSupplierInsuranceOptionInput } from "@/gql/graphql";
import { SupplierInsuranceOptionForm } from "@/app/Suppliers/Forms/SupplierInsuranceOptionForm";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { supplierInsuranceOptionValidationZod } from "@/app/Suppliers/Validation/supplierInsuranceOptionValidation";
import { toFormikValidationSchema } from "@/lib/Zod/zod-formik-adapter";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { createSupplierInsuranceOptionMutation } from "@/app/Suppliers/GraphQL/supplierInsuranceOptionMutations";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { DialogComponent } from "@/lib/Components/Dialog/Hooks/useDialog";
import { SupplierInsuranceOptionListItem } from "@/app/Suppliers/GraphQL/supplierInsuranceOptionListQuery";

export type SupplierInsuranceOptionCreateDialogProps = {
  initialValues?: Partial<CreateSupplierInsuranceOptionInput>;
};
export const SupplierInsuranceOptionCreateDialog: DialogComponent<
  SupplierInsuranceOptionCreateDialogProps,
  SupplierInsuranceOptionListItem
> = ({ initialValues }) => {
  const { mutateAsync } = useGqlMutation(createSupplierInsuranceOptionMutation);
  const { close, resolve } = useDialogState<SupplierInsuranceOptionListItem>();

  return (
    <BaseDialog title="Add insurance package">
      <GenericForm<CreateSupplierInsuranceOptionInput>
        validationSchema={toFormikValidationSchema(
          supplierInsuranceOptionValidationZod,
        )}
        initialValues={{
          name: "",
          bond_amount: null,
          standard_liability_amount: null,
          liability_reduction_options: "",
          supplier: null!,
          ...initialValues,
        }}
        onSubmit={async (values) => {
          const res = await mutateAsync({
            input: {
              ...values,
            },
          });

          resolve?.(res.createSupplierInsuranceOption);

          await close();
        }}
      >
        <SupplierInsuranceOptionForm type="create" />
        <DialogSubmitButton text={"Add insurance package"} />
      </GenericForm>
    </BaseDialog>
  );
};
